var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "power-add-dialog" }, [
    _c(
      "div",
      { staticClass: "dialog-body" },
      [
        _c(
          "el-form",
          {
            ref: "formHelpDoc",
            attrs: {
              "label-position": "top",
              model: _vm.formHelpDoc,
              rules: _vm.rules
            }
          },
          [
            _c(
              "el-form-item",
              {
                staticStyle: { height: "60px", "margin-bottom": "20px" },
                attrs: { label: "所属系统", prop: "systemId" }
              },
              [
                _c(
                  "el-select",
                  {
                    attrs: { size: "small", placeholder: "请选择系统名称" },
                    model: {
                      value: _vm.formHelpDoc.systemId,
                      callback: function($$v) {
                        _vm.$set(_vm.formHelpDoc, "systemId", $$v)
                      },
                      expression: "formHelpDoc.systemId"
                    }
                  },
                  _vm._l(_vm.AddformData[0].selectData, function(option, i) {
                    return _c("el-option", {
                      key: i,
                      attrs: { label: option.label, value: option.value }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "帮助文档上传", prop: "fileList" } },
              [
                _c("FileUpload", {
                  ref: "attachments",
                  staticClass: "file-upload",
                  attrs: {
                    type: "ATTACHMENT",
                    multiple: true,
                    url: "/platform/file/temporaryFile",
                    "format-text": ".doc,.docx,.pdf,且不超过50MB",
                    accept: ".doc,.docx,.pdf",
                    maxSize: 50
                  },
                  on: {
                    uploadSuccess: function($event) {
                      return _vm.uploadSuccess($event)
                    },
                    uploadError: function($event) {
                      return _vm.uploadError($event)
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _c("div", { staticClass: "dialog-footer" }, [
      _c("input", {
        staticClass: "btn",
        attrs: { type: "button", value: "取消" },
        on: { click: _vm.cancelDailog }
      }),
      _c("input", {
        staticClass: "btn btn-red",
        attrs: { slot: "reference", type: "button", value: "确认" },
        on: { click: _vm.commit },
        slot: "reference"
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }